import React from "react";
import { SidebarItem } from "./ISidebar";
import { Link, useLocation } from "react-router-dom";
import { Dropdown, Menu } from "antd";

interface SidebarProps {
  mainItems: SidebarItem[];
  bottomItems: SidebarItem[];
}

const Sidebar: React.FC<SidebarProps> = ({ mainItems, bottomItems }) => {
  // Render submenu for dropdown items
  const location = useLocation();

  const isActiveTab = (currentPath: string) => {
    const path = location.pathname;
    const normalize = (p: string) => p.replace(/^\/+|\/+$/g, "").toLowerCase();
    const tab = normalize(path);
    const current = normalize(currentPath);
    return current === tab || current.startsWith(`${tab}/`);
  };

  const renderDropdown = (item: SidebarItem) => {
    const menu = (
      <Menu>
        {item.children?.map((child, index) => (
          <Menu.Item key={index}>
            <Link to={child.href ?? "#"}>{child.name}</Link>
          </Menu.Item>
        ))}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={["click"]} key={item.name}>
        <div className="py-2 text-center cursor-pointer">
          <div className="flex items-center justify-center">
            <img src={item.icon} className="mx-auto" alt={item.name} />
          </div>
          <p className="text-font-size font-medium text-text-tertiary mt-1">
            {item.name} ▼
          </p>
        </div>
      </Dropdown>
    );
  };

  // Render regular sidebar items
  const renderItem = (item: SidebarItem, index: number) => {
    if (item.children) {
      return renderDropdown(item);
    }

    return (
      <li key={index} className="py-2 text-center cursor-pointer">
        <Link to={item.href ?? "#"}>
          <img src={item.icon} className="mx-auto" alt={item.name} />
          <p className="text-font-size font-medium text-text-tertiary mt-1">
            {item.name}
          </p>
        </Link>
      </li>
    );
  };

  return (
    <div className="w-20 h-calc-vh fixed left-0 top-dots-vertical-icon bg-white border-r border-main-border py-4 flex flex-col justify-between z-10">
      <ul>
        {mainItems.map((item, index) => (
          <li key={index} className={`py-2 text-center cursor-pointer ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"}`}>

            <Link to={item?.href ?? "#"} className="flex flex-col justify-center items-center" target={item.name === "Feedback" ? "_blank" : ""}>
              {typeof item.icon === "string" ? (
                <img src={item.icon} className="mx-auto" alt={item.name} style={item.name === "Feedback" ? { width: "43px" } : {}} />
              ) : (
                <span className={`text-inherit ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"} `}>
                  {item.icon}
                </span>
              )}
              <p className={`text-font-size font-medium ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"} mt-1`}>{item.name}</p>

            </Link>
          </li>
        ))}
      </ul>
      <ul>
        {bottomItems.map((item, index) => (
          <li key={index} className={`py-2 text-center cursor-pointer ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"}`}>
            <Link to={item?.href ?? "#"}>
              {typeof item.icon === "string" ? (
                <img src={item.icon} className="mx-auto flex justify-center self-center" alt={item.name} />
              ) : (
                <span className={`text-inherit flex justify-center ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"} `}>
                  {item.icon}
                </span>
              )}
              <p className={`text-font-size font-medium ${isActiveTab(item.href ?? "") ? "text-primary" : "text-text-tertiary"} mt-1`}>{item.name}</p>

            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
